import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faHeart,
  faBell,
  faEdit,
  faSave,
  faEye,
  faPlay,
  faClock,
  faEnvelope,
  faCalendar,
  faGlobe,
  faCheck,
  faTimes,
  faTrash,
  faCog
} from '@fortawesome/free-solid-svg-icons';
import '../styles/Profile.css';

const Profile = () => {
  const location = useLocation();
  const [user, setUser] = useState({
    name: 'Nguyễn Văn A',
    email: 'user@example.com',
    avatar: '/logo192.png',
    joinDate: '2024-01-15',
    totalWatched: 127,
    totalFavorites: 23,
    totalNotifications: 2
  });

  const [activeTab, setActiveTab] = useState('info');
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({ ...user });

  // Mock favorite movies data
  const [favoriteMovies, setFavoriteMovies] = useState([
    {
      id: 1,
      name: 'Attack on Titan',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BNzc5MTczNDQtNDFjNi00ZDU5LWFkNzItOTE1NzQzMzdhNzU5XkEyXkFqcGdeQXVyNjc2NjA5MTU@._V1_FMjpg_UX1000_.jpg',
      status: 'Đang xem',
      progress: '15/25 tập',
      lastWatched: '2024-08-07',
      rating: 9.2
    },
    {
      id: 2,
      name: 'Demon Slayer',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_FMjpg_UX1000_.jpg',
      status: 'Hoàn thành',
      progress: '44/44 tập',
      lastWatched: '2024-08-05',
      rating: 9.0
    },
    {
      id: 3,
      name: 'Your Name',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BODRmZDVmNzUtZDA4ZC00NjhkLWI2M2UtN2M0ZDIzNDcxYThjL2ltYWdlXkEyXkFqcGdeQXVyNTk0MzMzODA@._V1_FMjpg_UX1000_.jpg',
      status: 'Đã xem',
      progress: '1/1 tập',
      lastWatched: '2024-08-03',
      rating: 9.5
    },
    {
      id: 4,
      name: 'Spirited Away',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BMjlmZmI5MDctNDE2YS00YWE0LWE5ZWItZDBhYWQ0NTcxNWRhXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_.jpg',
      status: 'Yêu thích',
      progress: '1/1 tập',
      lastWatched: '2024-08-01',
      rating: 9.8
    },
    {
      id: 5,
      name: 'One Piece',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BODcwNWE3OTMtMDc3MS00NDFjLWE1OTAtNDU3NjgxODMxY2UyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg',
      status: 'Đang xem',
      progress: '892/1000+ tập',
      lastWatched: '2024-08-07',
      rating: 9.1
    },
    {
      id: 6,
      name: 'Naruto',
      poster_url: 'https://m.media-amazon.com/images/M/MV5BZmQ5NGFiNWEtMmMyMC00MDdiLWI4VWQtZTg0YWQ3MzI1ZDMzXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_FMjpg_UX1000_.jpg',
      status: 'Hoàn thành',
      progress: '720/720 tập',
      lastWatched: '2024-07-28',
      rating: 8.9
    }
  ]);

  // Mock notifications data
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'new_episode',
      title: 'Attack on Titan',
      message: 'Tập 16 mới đã được cập nhật',
      time: '2 giờ trước',
      read: false,
      poster: 'https://m.media-amazon.com/images/M/MV5BNzc5MTczNDQtNDFjNi00ZDU5LWFkNzItOTE1NzQzMzdhNzU5XkEyXkFqcGdeQXVyNjc2NjA5MTU@._V1_FMjpg_UX1000_.jpg'
    },
    {
      id: 2,
      type: 'new_episode',
      title: 'One Piece',
      message: 'Tập 893 mới đã được cập nhật',
      time: '5 giờ trước',
      read: false,
      poster: 'https://m.media-amazon.com/images/M/MV5BODcwNWE3OTMtMDc3MS00NDFjLWE1OTAtNDU3NjgxODMxY2UyXkEyXkFqcGdeQXVyNTAyODkwOQ@@._V1_.jpg'
    },
    {
      id: 3,
      type: 'favorite_update',
      title: 'Demon Slayer',
      message: 'Bộ phim trong danh sách yêu thích đã hoàn thành',
      time: '1 ngày trước',
      read: true,
      poster: 'https://m.media-amazon.com/images/M/MV5BZjZjNzI5MDctY2Y4YS00NmM4LTljMmItZTFkOTExNGI3ODRhXkEyXkFqcGdeQXVyNjc3MjQzNTI@._V1_FMjpg_UX1000_.jpg'
    },
    {
      id: 4,
      type: 'system',
      title: 'Hệ thống',
      message: 'Chào mừng bạn đến với MAnime!',
      time: '3 ngày trước',
      read: true,
      poster: '/logo192.png'
    },
    {
      id: 5,
      type: 'new_episode',
      title: 'Naruto',
      message: 'Bộ phim đã được thêm vào danh sách yêu thích',
      time: '1 tuần trước',
      read: true,
      poster: 'https://m.media-amazon.com/images/M/MV5BZmQ5NGFiNWEtMmMyMC00MDdiLWI4VWQtZTg0YWQ3MzI1ZDMzXkEyXkFqcGdeQXVyNTA4NzY1MzY@._V1_FMjpg_UX1000_.jpg'
    }
  ]);

  useEffect(() => {
    // Load user data from localStorage or API
    const savedUser = localStorage.getItem('userData');
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      setUser(userData);
      setEditData(userData);
    }

    // Check URL parameters for tab
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ['info', 'favorites', 'notifications'].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setUser(editData);
    localStorage.setItem('userData', JSON.stringify(editData));
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditData({ ...user });
    setIsEditing(false);
  };

  const handleInputChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const removeFavorite = (movieId) => {
    setFavoriteMovies(prev => prev.filter(movie => movie.id !== movieId));
  };

  const markNotificationRead = (notificationId) => {
    setNotifications(prev =>
      prev.map(notif =>
        notif.id === notificationId ? { ...notif, read: true } : notif
      )
    );
  };

  const deleteNotification = (notificationId) => {
    setNotifications(prev => prev.filter(notif => notif.id !== notificationId));
  };

  const clearAllNotifications = () => {
    setNotifications([]);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Đang xem':
        return '#3b82f6';
      case 'Hoàn thành':
        return '#10b981';
      case 'Đã xem':
        return '#6b7280';
      case 'Yêu thích':
        return '#ef4444';
      default:
        return '#6b7280';
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'new_episode':
        return faPlay;
      case 'favorite_update':
        return faHeart;
      case 'system':
        return faCog;
      default:
        return faBell;
    }
  };

  const tabs = [
    { id: 'info', label: 'Thông tin', icon: faUser },
    { id: 'favorites', label: 'Yêu thích', icon: faHeart },
    { id: 'notifications', label: 'Thông báo', icon: faBell }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'info':
        return (
          <div className="profile-info">
            <div className="info-header">
              <div className="avatar-section">
                <img src={user.avatar} alt="Avatar" className="user-avatar" />
                <div className="avatar-info">
                  {isEditing ? (
                    <input
                      type="text"
                      value={editData.name}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                      className="edit-input name-input"
                    />
                  ) : (
                    <h3 className="user-name">{user.name}</h3>
                  )}
                  {isEditing ? (
                    <input
                      type="email"
                      value={editData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      className="edit-input email-input"
                    />
                  ) : (
                    <p className="user-email">{user.email}</p>
                  )}
                </div>
              </div>
              <div className="edit-actions">
                {isEditing ? (
                  <>
                    <button className="save-btn" onClick={handleSave}>
                      <FontAwesomeIcon icon={faSave} />
                      Lưu
                    </button>
                    <button className="cancel-btn" onClick={handleCancel}>
                      <FontAwesomeIcon icon={faTimes} />
                      Hủy
                    </button>
                  </>
                ) : (
                  <button className="edit-btn" onClick={handleEdit}>
                    <FontAwesomeIcon icon={faEdit} />
                    Chỉnh sửa
                  </button>
                )}
              </div>
            </div>

            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-icon blue">
                  <FontAwesomeIcon icon={faEye} />
                </div>
                <div className="stat-info">
                  <h4>Đã xem</h4>
                  <span className="stat-value">{user.totalWatched}</span>
                  <p>Bộ phim</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon red">
                  <FontAwesomeIcon icon={faHeart} />
                </div>
                <div className="stat-info">
                  <h4>Yêu thích</h4>
                  <span className="stat-value">{user.totalFavorites}</span>
                  <p>Bộ phim</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon green">
                  <FontAwesomeIcon icon={faBell} />
                </div>
                <div className="stat-info">
                  <h4>Thông báo</h4>
                  <span className="stat-value">{user.totalNotifications}</span>
                  <p>Chưa đọc</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon purple">
                  <FontAwesomeIcon icon={faCalendar} />
                </div>
                <div className="stat-info">
                  <h4>Tham gia</h4>
                  <span className="stat-value">
                    {new Date(user.joinDate).toLocaleDateString('vi-VN')}
                  </span>
                  <p>Ngày đăng ký</p>
                </div>
              </div>
            </div>

            <div className="user-details">
              <h4>Thông tin chi tiết</h4>
              <div className="details-grid">
                <div className="detail-item">
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>Email</span>
                  <span>{user.email}</span>
                </div>
                <div className="detail-item">
                  <FontAwesomeIcon icon={faCalendar} />
                  <span>Ngày tham gia</span>
                  <span>{new Date(user.joinDate).toLocaleDateString('vi-VN')}</span>
                </div>
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} />
                  <span>Quốc gia</span>
                  <span>Việt Nam</span>
                </div>
              </div>
            </div>
          </div>
        );

      case 'favorites':
        return (
          <div className="favorites-section">
            <div className="section-header">
              <h3>Phim yêu thích ({favoriteMovies.length})</h3>
              <p>Danh sách các bộ phim bạn đã thêm vào yêu thích</p>
            </div>

            <div className="favorites-grid">
              {favoriteMovies.map(movie => (
                <div key={movie.id} className="favorite-card">
                  <div className="movie-poster">
                    <img src={movie.poster_url} alt={movie.name} />
                    <div className="movie-overlay">
                      <button className="play-btn">
                        <FontAwesomeIcon icon={faPlay} />
                      </button>
                      <button 
                        className="remove-btn"
                        onClick={() => removeFavorite(movie.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </div>
                  <div className="movie-info">
                    <h4 className="movie-title">{movie.name}</h4>
                    <div className="movie-meta">
                      <span 
                        className="status-badge"
                        style={{ backgroundColor: getStatusColor(movie.status) }}
                      >
                        {movie.status}
                      </span>
                      <span className="rating">★ {movie.rating}</span>
                    </div>
                    <p className="progress">{movie.progress}</p>
                    <p className="last-watched">
                      <FontAwesomeIcon icon={faClock} />
                      {movie.lastWatched}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      case 'notifications':
        return (
          <div className="notifications-section">
            <div className="section-header">
              <h3>Thông báo ({notifications.filter(n => !n.read).length} chưa đọc)</h3>
              <button className="clear-all-btn" onClick={clearAllNotifications}>
                Xóa tất cả
              </button>
            </div>

            <div className="notifications-list">
              {notifications.map(notification => (
                <div 
                  key={notification.id} 
                  className={`notification-card ${notification.read ? 'read' : 'unread'}`}
                >
                  <div className="notification-avatar">
                    <img src={notification.poster} alt={notification.title} />
                  </div>
                  <div className="notification-content">
                    <div className="notification-header">
                      <div className="notification-icon">
                        <FontAwesomeIcon icon={getNotificationIcon(notification.type)} />
                      </div>
                      <h4 className="notification-title">{notification.title}</h4>
                      <span className="notification-time">{notification.time}</span>
                    </div>
                    <p className="notification-message">{notification.message}</p>
                  </div>
                  <div className="notification-actions">
                    {!notification.read && (
                      <button 
                        className="mark-read-btn"
                        onClick={() => markNotificationRead(notification.id)}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    )}
                    <button 
                      className="delete-btn"
                      onClick={() => deleteNotification(notification.id)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-header">
          <h2>
            <FontAwesomeIcon icon={faUser} />
            Trang cá nhân
          </h2>
        </div>

        <div className="profile-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <FontAwesomeIcon icon={tab.icon} />
              <span>{tab.label}</span>
              {tab.id === 'notifications' && notifications.filter(n => !n.read).length > 0 && (
                <span className="notification-badge">
                  {notifications.filter(n => !n.read).length}
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="profile-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Profile;
